var map = {
	"./aval.png": 2732,
	"./bnb.png": 325,
	"./bsc.png": 7144,
	"./cryptocoins/alwin.png": 6883,
	"./cryptocoins/btc.png": 3420,
	"./cryptocoins/eth.png": 1450,
	"./cryptocoins/ltc.png": 9629,
	"./cryptocoins/steem.png": 9980,
	"./cryptocoins/usdt.png": 8880,
	"./exchange_icon.png": 2125,
	"./fantom.png": 3984,
	"./goerli.png": 2462,
	"./meta_mask_logo.png": 9258,
	"./metamask.png": 8843,
	"./mumbai.png": 8250,
	"./polygon.png": 2549,
	"./trustwallet.png": 9414,
	"./walletconnect.png": 6354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;